import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { DefaultSubscription } from "../models/DefaultSubscription";
import { UserSubscription } from "../models/UserSubscription";
import { SubscriptionType } from "./../models/Enums";
import { User } from "./../models/User";

@Injectable({
  providedIn: "root",
})
export class SubscriptionService {
  defaultSubscriptions: DefaultSubscription[];
  types: string[];

  private baseUrl_V2 = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/admin/subscriptions`;

  constructor(private http: HttpClient) {}

  private getTypes() {
    return this.http.get<string[]>(this.baseUrl_V2 + "/params");
  }

  private getDefault(): Observable<DefaultSubscription[]> {
    return this.http.get<DefaultSubscription[]>(this.baseUrl_V2 + "/default");
  }

  updateDefault(subscriptions) {
    return this.http.put(this.baseUrl_V2 + "/default", subscriptions);
  }

  async getUserSubscriptionList(user: User) {
    this.defaultSubscriptions = await this.getDefault().toPromise();
    this.types = await this.getTypes().toPromise();

    const userSubscriptions: UserSubscription[] = [];
    const isNewUser = !user.userId;

    for (const key in this.types) {
      const name = this.types[key];
      const subscription = isNewUser ? null : user.subscriptions.find((x) => x.name === name);
      const title = this.subscriptions.find((x) => x.name == name).title;
      if (subscription)
        userSubscriptions.push(
          new UserSubscription(
            subscription.name,
            subscription.activeFrom,
            subscription.activeTo,
            true,
            title,
          ),
        );
      else {
        const d = new UserSubscription();
        d.name = name;
        d.title = this.subscriptions.find((x) => x.name == d.name).title;
        const duration =
          this.defaultSubscriptions.find((x) => x.role === user.role && x.subscription === name)
            ?.durationDays ?? 365;
        const date = new Date();
        d.activeFrom = new Date();
        d.activeTo = new Date(date.setDate(date.getDate() + duration));
        d.isActive = isNewUser
          ? this.defaultSubscriptions.some((x) => x.role === user.role && x.subscription === name)
          : false;
        userSubscriptions.push(
          new UserSubscription(d.name, d.activeFrom, d.activeTo, d.isActive, d.title),
        );
      }
    }
    return userSubscriptions;
  }

  subscriptions: UserSubscription[] = [
    {
      name: SubscriptionType.ServiceRequest,
      title: "subscription.servicerequest",
    },
    { name: SubscriptionType.CswCheckIn, title: "subscription.cswcheckin" },
    { name: SubscriptionType.Contracts, title: "subscription.contract" },
    { name: SubscriptionType.EditTool, title: "subscription.tooledit" },
    {
      name: SubscriptionType.PurchaseOrder,
      title: "subscription.purchaseorder",
    },
    { name: SubscriptionType.FieldService, title: "subscription.fieldservice" },
    { name: SubscriptionType.HomeGraphs, title: "subscription.homecharts" },
    { name: SubscriptionType.Reminders, title: "subscription.reminders" },
    { name: SubscriptionType.AddTool, title: "subscription.addtool" },
    { name: SubscriptionType.TechCover, title: "subscription.techCover" },
  ];
}
